import { AnimatePresence, motion } from "framer-motion";
import { twMerge } from "tailwind-merge";

import { Spinner } from "@/components/ui/Spinner";

export function LinkButton({
  children,
  onClick,
  className,
  testId,
  loading,
}: {
  testId?: string;
  children: React.ReactNode;
  onClick: () => void;
  className?: string;
  loading?: boolean;
}) {
  return (
    <button
      data-testid={testId}
      className={twMerge(
        "text-sm font-semibold leading-6 text-gray-900 transition-colors hover:text-gray-600 disabled:cursor-wait",
        className
      )}
      // A click already in flight (e.g. opening a Stripe portal) must not be repeatable.
      disabled={loading !== undefined && loading}
      onClick={onClick}
    >
      {children}
      <AnimatePresence mode="wait">
        {loading !== undefined && loading && (
          <motion.div
            key="spinner"
            className="ml-2 flex items-center"
            initial={{ opacity: 0, scale: 0, x: -10 }}
            animate={{ opacity: 1, scale: 1, x: 0 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.2 }}
          >
            <Spinner />
          </motion.div>
        )}
      </AnimatePresence>
    </button>
  );
}
